export default {
    mapLandmarkBulk_title: "Bulk Landmark Actions",
    mapLandmarkBulk_iconType: "Icon Type",
    mapLandmarkBulk_custom: "Custom",
    mapLandmarkBulk_Icon_color: "Icon & Color",
    mapLandmarkBulk_landmark: "Landmarks updated",
    mapLandmarkBulk_landmark_selected: "Landmarks Selected",
    mapLandmarkBulk_selectedLandmarks: "The selected landmarks will belong to the following Group",
    mapLandmarkBulk_tag: "Tag",
};